import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/common/Header";

const CandidateDashboardLayout = () => {
  return (
    <div className="md:grid xl:grid-cols-6 lg:grid-cols-5 md:grid-cols-4 min-h-screen bg-gray-50">
      <Sidebar />
      <div className=" scroll-auto xl:col-span-5 lg:col-span-4 md:col-span-3">
        <div className="p-8">
          <Header />
          <main>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default CandidateDashboardLayout;
